import base_ds from "@/services/base_datasource_service";
import request from "@/utils/request";
import { AxiosResponse } from "axios";
import { TransportIncome, TransportIncomeTotal } from "./models-service";
import { exportToExcelFile } from "@/utils/excel";

export const route_ns = `transport_income`;
export const route_ns_total = `total_transport_income`;

class TransportIncomesInputService {
  public crud = base_ds.getBaseCrud(route_ns);

  public async getWithFilter(ids: String[], id_facility: number, periods: String[]): Promise<TransportIncome[]> {
    const url = `${route_ns}?filter=[["id_cut","in",${JSON.stringify(ids)}],"and",["id_eco_facility","=","${id_facility}"],"and",["month","in",${JSON.stringify(periods)}]]`
    const response: AxiosResponse["data"] = await request({
      url: url,
      method: "get",
    });
    let result = [];
    if(response && response.data) {
      result = response.data;
    }
    return result;
  }

  public async save(pack: TransportIncome[]) {
    return await request({
      url: route_ns,
      method: "post",
      data: {data: pack},
    });
  }

  public async delete(list: TransportIncome[]) {
    return await request({
      url: route_ns,
      method: "delete",
      data: {data: list},
    });
  }

  public async getTotalWithFilter(ids: String[], id_facility: number, periods: String[]): Promise<TransportIncomeTotal[]> {
    const url = `${route_ns_total}?filter=[["id_cut","in",${JSON.stringify(ids)}],"and",["id_eco_facility","=","${id_facility}"],"and",["month","in",${JSON.stringify(periods)}]]`
    const response: AxiosResponse["data"] = await request({
      url: url,
      method: "get",
    });
    let result = [];
    if(response && response.data) {
      result = response.data;
    }
    return result;
  }

  public async getChangedTotal(id_cut: string, id_facility: number, blocks: string[], periods: String[]): Promise<TransportIncomeTotal[]> {
    let is_total = `["block","in",${JSON.stringify(blocks)}]`;
    if (blocks.includes('total')) {
      is_total = `[["block","in",${JSON.stringify(blocks)}],"or",["is_total","=","true"]]`;
    }
    const url = `${route_ns_total}?filter=[["id_cut","=","${id_cut}"],"and",["id_eco_facility","=","${id_facility}"],"and",${is_total},"and",["month","in",${JSON.stringify(periods)}]]`
    const response: AxiosResponse["data"] = await request({
      url: url,
      method: "get",
    });
    let result = [];
    if(response && response.data) {
      result = response.data;
    }
    return result;
  }

  public async saveTotal(pack: TransportIncomeTotal[]) {
    return await request({
      url: route_ns_total,
      method: "post",
      data: {data: pack},
    });
  }

  public async exportToExcel(data: any, filename: string | null = null) {
    await exportToExcelFile(data, route_ns_total, filename);
  }
}

export default new TransportIncomesInputService();
